import * as actions from './getUserActions';

const getUserReducer = {
  [actions.USER_GET_USER_SUCCESS_RECEIVED]: (state, { payload }) => {
    const { fName, lName } = payload;
    const initials = `${fName && fName.charAt(0)}${lName && lName.charAt(0)}`;
    state.profile = {
      ...payload,
      initials,
    };

    return { ...state, userEmail: payload.userEmail };
  },
};

export default getUserReducer;
